import { useMutation } from '@tanstack/react-query'

import { Methods } from '@/api/v1/orders/_orderNo@string'
import { aspidaClient } from '@/lib/aspida'
import { MutationConfig } from '@/lib/react-query'

export type UpdateOrderDTO = {
  orderNo: string
  data: Methods['put']['reqBody']
}

export const updateOrder = ({ orderNo, data }: UpdateOrderDTO) => {
  return aspidaClient.v1.orders._orderNo(orderNo).$put({ body: data })
}

type UseUpdateOrderOptions = {
  config?: MutationConfig<typeof updateOrder>
}

export const useUpdateOrder = ({ config }: UseUpdateOrderOptions) => {
  return useMutation({
    ...config,
    mutationFn: updateOrder,
  })
}
